import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

export const TrimaRankingCardWrapper = styled.div<{ $isDragging?: boolean; $opacity?: number }>`
  display: flex;
  align-items: center;
  gap: ${prem(12)};
  padding: ${prem(14)} ${prem(14)};
  background: var(--ion-background-color, #ffffff);
  border: 1px solid var(--ion-color-light, #e5e5e5);
  border-radius: ${prem(10)};
  user-select: none;
  touch-action: none;
  cursor: grab;
  opacity: ${({ $opacity }) => ($opacity != null ? $opacity : 1)};
  box-shadow: ${({ $isDragging }) =>
    $isDragging ? '0 8px 20px rgba(0, 0, 0, 0.15)' : '0 1px 2px rgba(0, 0, 0, 0.04)'};
  transform: ${({ $isDragging }) => ($isDragging ? 'scale(1.02)' : 'none')};
  transition: box-shadow 0.15s ease, transform 0.15s ease;

  &:active {
    cursor: grabbing;
  }

  .trima-handle {
    color: var(--ion-text-color-secondary);
    font-size: ${prem(18)};
    line-height: 1;
    flex-shrink: 0;
    opacity: 0.5;
  }

  .trima-card-label {
    flex: 1;
    font-size: ${prem(14)};
    line-height: 1.4;
    color: var(--ion-text-color);
  }
`;
